import { useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../lib/firebaseConfig';
import { useAuth } from '../hooks/auth';

const useShopifyConnection = () => {
  const [isConnecting, setIsConnecting] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [shopifyUrlForFirebase, setShopifyUrlForFirebase] = useState('');
  const { user } = useAuth();

  // Ajoutez ici vos constantes API
  const YOUR_API_KEY = '569e593596a77f1643cbe585cbaf053a';
  const YOUR_API_SECRET = '9b92900344267493861b2598bcca4a72';
  const YOUR_REDIRECT_URI = 'http://localhost:3000/oauth/callback';

  const connect = async (shopifyUrl) => {
    try {
      setIsConnecting(true);

      // Generate the authorization URL for Shopify
      const authUrl = `https://${shopifyUrl}/admin/oauth/authorize?client_id=${YOUR_API_KEY}&scope=read_products,write_products&redirect_uri=${YOUR_REDIRECT_URI}`;

      setIsConnecting(false);

      // Redirect the user to the authorization URL
      window.location.href = authUrl;

      // Update the Shopify URL in Firebase
      const userRef = doc(db, 'Shopify', user.uid);
      await setDoc(userRef, { shopifyUrl });

    } catch (error) {
      setIsConnecting(false);
      setErrorMessage('Failed to connect to Shopify');
      console.error('Error connecting to Shopify:', error);
      throw error;
    }
  };

  return {
    isConnecting,
    isConnected,
    errorMessage,
    shopifyUrlForFirebase,
    connect,
    setIsConnecting,
    setIsConnected,
    setErrorMessage,
    setShopifyUrlForFirebase,
  };
};

export default useShopifyConnection;
